// extracted by mini-css-extract-plugin
export default {"card":"FeedItem_card__Lg9ix","body":"FeedItem_body__ChqkY","title":"FeedItem_title__6YZT7","text":"FeedItem_text__DKMCm"};